import React, { useContext } from 'react'

/**
 * True while the customer view is rendering for a PDF (`?pdf=1`, i.e. Browserless).
 *
 * Lets deep components pick a lighter asset for the PDF without prop-drilling —
 * e.g. FilePreview swaps a provider photo's full-size `src` for its downsized
 * `providerPrintSrc` (#23666). Set from the URL rather than from print media,
 * because Browserless only emulates print media after images have loaded
 * (`render-with-browserless.ts`); a swap at that point would start a second image
 * load that nothing waits for.
 */
export const PdfRenderContext = React.createContext<boolean>(false)

export function PdfRenderProvider({ isPdf, children }: { isPdf?: boolean; children: React.ReactNode }) {
  return <PdfRenderContext.Provider value={!!isPdf}>{children}</PdfRenderContext.Provider>
}

export const usePdfRender = () => useContext(PdfRenderContext)

export default PdfRenderProvider
